import { atom } from "recoil";

const authModalState = atom({
    key: "authModalState",
    default: {
        open: false
    },
});

export { authModalState };